import { ComponentType, OverlayContainer } from '@angular/cdk/overlay';
import { Component, HostBinding, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSidenav } from '@angular/material/sidenav';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'pros-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {

  title = 'ngx-auth';
  routerSub: Subscription;
  dialogRef: MatDialogRef<Component>;

  @HostBinding('class') componentCssClass;
  themeSub: Subscription;

  @ViewChild('rightSideNav', { static: true })
  rightSideNav: MatSidenav;
  @ViewChild('rightSideNav2', { static: true })
  rightSideNav2: MatSidenav;

  themes = [
    { name: 'default-theme', primary: '#FD6329', bg: '#fafafa' },
    { name: 'mdo-dark', primary: '#1976d2', bg: '#303030' },
    { name: 'ckh-light', primary: '#4caf50', bg: '#fafafa' },
    { name: 'ckh-dark', primary: '#4caf50', bg: '#303030' },
    { name: 'pros-theme', primary: '#FD6329', bg: '#303030' }
  ];

  matSidenavClasses: object = {};
    constructor(
    private overlayContainer: OverlayContainer,
    private router: Router,
    private matDialog: MatDialog
  ) { }

  ngOnInit(): void {
    // this.routerSub = this.router.events.pipe(
    //   filter(evt => evt instanceof NavigationEnd)
    // ).subscribe((evt: NavigationEnd) => {
    //   if (evt.url.match('sb2:') && !evt.url.includes('returnUrl=')) {
    //     this.rightSideNav2.open();
    //   }
    //   else {
    //     this.rightSideNav2.close();
    //   }
    //   if (evt.url.includes('sb:') && !evt.url.includes('returnUrl=')) {
    //     this.rightSideNav.open();
    //   } else {
    //     this.rightSideNav.close();
    //   }
    // });

  }

  ngOnDestroy(): void {
    // this.themeSub.unsubscribe();
  }

}
